import { createContext, useContext } from 'react';

export interface SSRResponseStatus {
  statusCode: number;
}

export const SSRResponseStatusContext = createContext<SSRResponseStatus | null>(
  null,
);

export const createSSRResponseStatus = (): SSRResponseStatus => ({
  statusCode: 200,
});

/**
 * Signals an HTTP status code from a React component to the SSR server.
 * No-op on the client.
 */
export const useHttpStatus = (code: number) => {
  const ctx = useContext(SSRResponseStatusContext);

  if (typeof window === 'undefined' && ctx && code > ctx.statusCode) {
    ctx.statusCode = code;
  }
};
